document.addEventListener('DOMContentLoaded',() => {
    checkLocalStorage();
});

// ローカルストレージにcheckout_urlがあるかを確認する
async function checkLocalStorage() {
    const myPageButton = document.getElementById("cutomer__myPage");
    const purchaseButton = document.getElementById("cutomer__purchase");
    // ローカルストレージからcheckout_urlを取得する
    const checkout_url = localStorage.getItem("checkout_url");
    // checkout_urlがnullではない場合：
    if(checkout_url){
        // ご購入手続きへボタンを表示
        purchaseButton.style.display = "flex";
        // ローカルストレージから取得したurlをご購入手続きへボタンにセットする
        purchaseButton.addEventListener("click",function(){
            window.location.href = checkout_url;
        });
        // ローカルストレージからcheckout_urlを削除する
        localStorage.removeItem("checkout_url");
    }// checkout_urlがnullの場合
    else{
        const customerInfomation = window.customerData;
        // マイページボタンを表示
        myPageButton.style.display = "flex";
        myPageButton.addEventListener("click",function(){
            window.location.href = customerInfomation.shopDomain + "/account";
        })
    }
}